import { useEffect, useState } from "react";

export interface IPagingProps {
    currentPage: number;
    totalResults: number;
    resultsPerPage: number;
    onChangePage: (pageNo: number) => void;
}

export default function Paging(props: IPagingProps) {
    const [totalPages, setTotalPages] = useState<number>(1);

    useEffect(() => {
        let pageCount = Math.floor(props.totalResults / props.resultsPerPage);
        if(props.totalResults % props.resultsPerPage !== 0) pageCount++;
        setTotalPages(pageCount);
    }, [props.totalResults, props.resultsPerPage]);

    return (<>
        {totalPages <= 1 && (<></>)}
        {totalPages > 1 && (
            <>
                <div className="paging-container flex justify-right">
                    <button disabled={props.currentPage === 1} className="btn-paging prev" onClick={() => props.onChangePage(props.currentPage - 1)}>Previous</button>
                    {Array(totalPages).fill(0).map((_, page) => 
                        <button key={`page_${page + 1}`} 
                                disabled={props.currentPage === page + 1} 
                                className="btn-paging active"
                                onClick={() => props.onChangePage(page + 1)}>
                                    {page + 1}
                        </button>)}
                    <button disabled={props.currentPage === totalPages} className="btn-paging next" onClick={() => props.onChangePage(props.currentPage + 1)}>Next</button>
                </div>
            </>
        )}
    </>);
}